var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'atom-scroll-up': true, active: _vm.isScrolled },on:{"click":_vm.goBackToTopSection}},[_c('AtomsCommonAtomIcon',{attrs:{"icon":"angle-up","size":30,"color":"#000"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }